import React from 'react';

import NoAuthPage from 'shared/ui/ErrorPage/NoAuthPage';

const NoAuth = () => {
    return  <NoAuthPage/>;
};

export default NoAuth;